import * as angular from 'angular';

export class NotificationsFactory {
    private apiRoot: string = '/api/v1/notifications';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    count() {
        return this.$http.get(
            `${this.apiRoot}/read/`
        );
    }
}

angular
    .module('app')
    .service('NotificationsFactory', NotificationsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/notifications.factory.ts